import { ArrowRight } from "lucide-react"

const caseStudies = [
  {
    stat: "500+",
    title: "Scaling Healthcare Analytics",
    description: "Leading healthcare system connected 500+ data sources using BridgeGate, reducing integration time by 85%.",
    company: "Enterprise Health System",
  },
  {
    stat: "1M+",
    title: "E-Prescriptions Streamlined",
    description: "Streamlined 1M+ e-prescriptions per month with automated EMR data synchronization.",
    company: "Regional Pharmacy Network",
  },
  {
    stat: "200+",
    title: "Provider Data Integration",
    description: "Simplified data exchange across 200+ providers with standardized FHIR transformations.",
    company: "Health Information Exchange",
  },
  {
    stat: "2M+",
    title: "Patient Records Unified",
    description: "Unified 2M+ patient records across multiple EMR systems for a comprehensive health view.",
    company: "Multi-Hospital Network",
  },
  {
    stat: "3M+",
    title: "Claims Processing Accelerated",
    description: "Accelerated processing of 3M+ claims annually with real-time eligibility verification.",
    company: "Insurance Provider",
  },
  {
    stat: "3M+",
    title: "Enterprise Data Platform",
    description: "Built enterprise integration platform handling 3M+ daily transactions across systems.",
    company: "Healthcare Technology Co.",
  },
]

export function CaseStudiesSection() {
  return (
    <section id="case-studies" className="py-20 lg:py-24 bg-[#faf5f7]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-4">
          <p className="text-[#9e3667] font-semibold text-sm uppercase tracking-wide">Real Outcomes</p>
        </div>
        <div className="text-center mb-14">
          <h2 className="text-3xl font-bold tracking-tight text-[#2d2d3a] sm:text-4xl">
            Real Outcomes.{" "}
            <span className="bg-[linear-gradient(135deg,#a63083,#bf406a)] bg-clip-text text-transparent">Real Impact.</span>
          </h2>
          <p className="mt-4 text-lg text-[#6b6b7b] max-w-2xl mx-auto">
            See how leaders are using our platform to improve speed, accuracy, and scale — without adding complexity.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {caseStudies.map((study) => (
            <div 
              key={study.title} 
              className="bg-white rounded-xl p-6 border border-[#e8e8ec] hover:border-[#9e3667]/40 hover:shadow-lg transition-all"
            >
              <p className="text-4xl font-bold text-[#9e3667] mb-3">{study.stat}</p>
              <h3 className="text-base font-semibold text-[#2d2d3a] mb-2">{study.title}</h3>
              <p className="text-sm text-[#6b6b7b] leading-relaxed mb-4">{study.description}</p>
              <p className="text-xs text-[#9a9aaa] font-medium">{study.company}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a 
            href="https://vorro.net"
            className="inline-flex items-center gap-2 text-[#9e3667] hover:text-[#843054] font-medium transition-colors"
          >
            View All Case Studies
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  )
}
